module.exports = __webpack_public_path__ + "static/media/logofooter.d3c9d1d3.svg";